import { Toast, toast } from "@/components/Toast";
import { PasteMeta } from "@/types/meta";
import { Actions } from "@/utils/api";
import { useOwnToast } from "@/utils/misc";
import { SafeOp } from "@/utils/safeOp";
import { BoardStore, langStore, useIsReady } from "@noli/business";
import { FileDropper, ClipBoard as NoliClipBoard } from "@noli/core";
import { useEffect } from "react";
async function getPasteClipboardData(event: ClipboardEvent) {
  console.log(event, "paste");
  const text = event.clipboardData?.getData("text");
  console.log("text: ", text);
  const files = event.clipboardData?.files;
  console.log("files: ", files);
  const types = event.clipboardData?.types;
  console.log("types: ", types);

  let result: {
    type: "success" | "failed" | "empty";
    msg: null | string;
    response: {
      type: "text" | "image";
      mime: string;
      source: File | string;
    } | null;
  } = {
    type: "empty",
    msg: null,
    response: null,
  };
  const fileType = types?.find((type) => /Files$/.test(type));
  const textType = types?.find((type) => /text\/plain$/.test(type));

  // 文字
  if (textType) {
    const text = event.clipboardData?.getData("text") ?? "";
    if (text && !/Packs/.test(text)) {
      result = {
        type: "success",
        msg: "",
        response: {
          type: "text",
          mime: textType,
          source: text.slice(0, 300),
        },
      };
    }
    return result;
  }

  // 图片
  if (fileType && files?.length) {
    const imageFiles = [];
    for (let i = 0; i < files.length; i++) {
      if (imageFiles.length) {
        continue;
      }
      const file = files.item(i);
      if (file && /(png|jpe?g)$/.test(file.type)) {
        imageFiles.push(file);
      } else if (i === files.length - 1) {
        result = {
          type: "failed",
          msg: "只支持粘贴 png/jpg/jpeg 格式的图片",
          response: null,
        };
        return result;
      }
    }

    const image = imageFiles[0];
    console.log("imageFiles: ", imageFiles);

    if (image) {
      const imageBuffer = await image.arrayBuffer();
      let errorFlag = false;
      let width = 0,
        height = 0;
      if (/png$/i.test(image.type)) {
        const size = FileDropper.getPngSize(imageBuffer);
        width = size.width;
        height = size.height;
      }
      if (/jpe?g$/i.test(image.type)) {
        const size = FileDropper.getJpgSize(imageBuffer);
        width = size.width;
        console.log("width: ", width);
        height = size.height;
        console.log("height: ", height);
      }

      if (!FileDropper.bitImageOverSizeCheck(image.size, width, height)) {
        errorFlag = true;
        result.msg = "图片大小/尺寸超出限制";
        result.type = "failed";
        return result;
      }

      result.type = "success";
      result.response = {
        type: "image",
        mime: image.type,
        source: image,
      };
    }
  }
  return result;
}

async function uploadImage(e: ClipboardEvent) {
  const result = await getPasteClipboardData(e);
  const lang = langStore.tgt;
  if (result.type === "success") {
    if (result.response?.type === "image") {
      const buffer = await (result.response.source as File).arrayBuffer();
      const res = await SafeOp.uploadImage(
        toast,
        lang,
        new Blob([buffer], { type: result.response.mime }),
        {
          failed: async () => {
            console.log("err upload");
            // toast({ status: "error", title: "粘贴图片失败" });
          },
          returnWH: true,
        },
      );
      if (!res) return;
      const {
        urls: { cdn },
        wh,
      } = res;
      const meta: PasteMeta = {
        type: "upload",
        data: {
          url: cdn,
          wh: wh,
          timestamp: Date.now(),
          isPaste: true,
        },
      };
      await Actions.importMeta({
        t: toast,
        lang,
        type: "upload",
        meta,
        setupInfo: {
          checkBusy: false,
          busyAliases: [".upload."],
        },
        opt: null,
      });
    }
    // if (result.response?.type === "text") {

    // }
  } else {
    Toast({
      status: "error",
      title: result.msg,
    });
  }
}

async function pasteProxy(e: ClipboardEvent | KeyboardEvent) {
  if (e.type === "copy") {
    if (e.target !== document.body) {
      NoliClipBoard.copyPacks.length = 0;
      NoliClipBoard.cutPacks.length = 0;
    }
  }
  if (e.type === "paste") {
    const evt = e as ClipboardEvent;
    const target = evt.target as HTMLElement;
    if (evt.clipboardData?.files.length && !["TEXTAREA", "INPUT"].includes(target.nodeName)) {
      uploadImage(evt);
    } else if (target.nodeName === "BODY") {
      NoliClipBoard.isCut
        ? BoardStore.api.keyboardPasteCut({})
        : BoardStore.api.keyboardAutoPaste({});
    }
  }
  if (e.type === "keydown") {
    const evt = e as KeyboardEvent;
    if (!evt.ctrlKey && !evt.metaKey) return;
    switch (evt.key) {
      case "x":
        navigator.clipboard.writeText("");
        await BoardStore.api.keyboardCut({});
        break;
      case "c":
        navigator.clipboard.writeText("");
        await BoardStore.api.keyboardCopy();
        break;
    }
  }
}

/**
 * 这个函数对画板复制粘贴等操作做全部代理，主要为了避免系统级复制粘贴与画板复制粘贴产生的冲突
 */
export const useCopyPaste = () => {
  const isReady = useIsReady();
  useEffect(() => {
    if (isReady) {
      BoardStore.api.enableKeyboard({
        enableCut: false,
        enableCopy: false,
        enablePaste: false,
      });
      document.addEventListener("paste", pasteProxy);
      document.addEventListener("copy", pasteProxy);
      document.getElementById("board.container")?.addEventListener("keydown", pasteProxy);
    }
    return () => {
      document.removeEventListener("paste", pasteProxy);
      document.removeEventListener("copy", pasteProxy);
      document.getElementById("board.container")?.removeEventListener("keydown", pasteProxy);
    };
  }, [isReady]);
};
